import { Product } from '@api/catalog/products/products.models';
import { LazyImage } from '@features/cms-render/domain/models/lazyImage';

export const PRODUCT_CAROUSEL_DEFAULT_NUMBER_COLUMNS = 5;
export const PRODUCT_CAROUSEL_DEFAULT_NUMBER_ROWS = 1;
export const PRODUCT_CAROUSEL_DEFAULT_NUMBER_MAX_BULLET_PAGES = 10;
export const PRODUCT_IMAGE_CLASS = 'product-single';

export type PieceProductCarouselViewStyle = 'double-image' | 'grid-image' | 'silhouette-image' | 'xmedia-location';
export type PieceProductCarouselSource = 'category' | 'productBundle' | 'productList';
export type BorderRadiusType = 'custom' | 'round' | 'semiRounded' | 'straight';

export interface ProductCarousel extends Product {
    categoryId: string;
    productImageData: LazyImage;
}
